<template>
  <div class="optionalCode">
    <el-row :gutter="20">
      <el-col
        :span="4"
        class="stepTitle"
      >
        <span class="label">
          {{ $t('optionalCode.title') }}
        </span>
      </el-col>
      <el-col
        :span="17"
        :offset="2"
      >
        <div>
          <div>
            <el-row
              class="codeRow"
              :gutter="20"
              v-for="(codeItem, index) in codeList"
              :key="codeItem.id"
            >
              <el-col :span="4">
                <el-select v-model="codeItem.type">
                  <el-option
                    v-for="item in optionalCodeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="8">
                <file-upload
                  :name="codeItem.fileName"
                  accept=".zip,.rar"
                  type="button"
                  @clear="handleClear(index)"
                  @start="(file) => handleUploadStart(index, file)"
                  @end="(type, file) => handleUploadEnd(index, type, file)"
                ></file-upload>
              </el-col>
              <el-col :span="3">
                <el-button
                  v-if="codeList.length > 1"
                  type="text"
                  @click="handleDeleteCode(index)"
                >
                  <i class="el-icon-remove addIcon"></i>
                </el-button>
                <el-button
                  v-if="index === codeList.length - 1"
                  type="text"
                  @click="handleAddCode"
                >
                  <i class="el-icon-circle-plus addIcon"></i>
                </el-button>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="18">
                <div
                  v-if="status === 'progress'"
                  style="margin-top: 20px;"
                >
                  <progress-bar></progress-bar>
                  <p class="fileTip">{{ $t('optionalCode.uploading') }} <span class="fileName">{{currFileName}}</span>...</p>
                </div>
                <div
                  v-if="status === 'success'"
                  style="margin-top: 20px;"
                >
                  <progress-bar done></progress-bar>
                  <p class="fileTip">{{ $t('optionalCode.upload') }} <span class="fileName">{{currFileName}}</span> {{ $t('optionalCode.uploadSuccess') }}</p>
                </div>
                <div
                  v-if="status === 'error'"
                  style="margin-top: 20px;"
                >
                  <progress-bar
                    status="exception"
                    done
                  ></progress-bar>
                  <p class="fileTip">
                    {{ $t('optionalCode.upload') }}
                    <span class="fileName">
                      {{currFileName}}
                    </span>
                    <i18n path="optionalCode.uploadFailed">
                      <template
                        #0
                        v-if="errorMessage"
                      >
                        <span class="errorMessage">
                          "{{errorMessage}}"
                        </span>
                        <span>,</span>
                      </template>
                    </i18n>
                  </p>
                </div>
              </el-col>
              <el-col :span="18">
                <el-tag
                  type="info"
                  class=" upload-instruction"
                >
                  <div>
                    <div>{{ $t('optionalCode.uploadInstruction') }}</div>
                    <br>
                    <div v-html="$t('optionalCode.tooltip')" />
                  </div>
                </el-tag>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import fileUpload from '@/components/file-upload.vue';
import ProgressBar from '@/components/progress-bar.vue';

export default {
  components: { fileUpload, ProgressBar },
  name: 'OptionalCode',
  props: {
    payload: Object,
  },
  data() {
    const { sourceCodeInfos = [] } = this.payload || {};
    const codeList = sourceCodeInfos.length
      ? sourceCodeInfos.map((item) => ({
          id: Math.random(),
          type: item.type,
          fileName: item.fileName,
          codeSha: item.sourceCode,
        }))
      : [
          {
            id: Math.random(),
            type: 'BACKEND',
            fileName: '',
            codeSha: '',
          },
        ];

    return {
      optionalCodeList: [
        {
          label: this.$t('optionalCode.frontend'),
          value: 'FRONTEND',
        },
        {
          label: this.$t('optionalCode.backend'),
          value: 'BACKEND',
        },
      ],
      codeList,
      status: 'init',
      currFileName: '',
      errorMessage: '',
    };
  },
  watch: {
    status(val) {
      if (val === 'progress') {
        this.$emit('next-loading', true);
      } else {
        this.$emit('next-loading', false);
      }
    },
  },
  methods: {
    handleUploadStart(index, file) {
      this.status = 'progress';
      this.codeList[index].fileName = file.fileName;
      this.currFileName = file.fileName;
      this.errorMessage = '';
    },
    handleUploadEnd(index, type, res) {
      if (type === 'success') {
        this.status = 'success';
        this.codeList[index].codeSha = res.sha256;
      } else {
        this.status = 'error';
        this.errorMessage = res?.message || '';
      }
    },
    handleClear(index) {
      const oldCode = this.codeList[index];

      this.codeList.splice(index, 1, {
        id: Math.random(),
        type: oldCode.type,
        fileName: '',
        codeSha: '',
      });

      this.status = 'init';
    },
    handleAddCode() {
      this.codeList.push({
        id: Math.random(),
        type: 'BACKEND',
        fileName: '',
        codeSha: '',
      });

      this.status = 'init';
    },
    handleDeleteCode(index) {
      this.codeList.splice(index, 1);
    },
    next() {
      if (this.status === 'progress') {
        this.$message.error(this.$t('optionalCode.waitForUpload'));
        return;
      }

      if (this.status === 'error') {
        this.$message.error(this.$t('optionalCode.uploadFailedTryAgain'));
        return;
      }

      const sourceCodeList = this.codeList
        .filter((item) => item.codeSha && item.type)
        .map((item) => ({
          type: item.type,
          fileName: item.fileName,
          sourceCode: item.codeSha,
        }));

      return {
        stage: 'OptionalCode',
        data: {
          sourceCodeInfos: sourceCodeList,
        },
      };
    },
  },
};
</script>

<style lang="scss">
.optionalCode {
  .label {
    font-weight: bold;
    line-height: 40px;
    white-space: nowrap;
  }

  .upload-instruction {
    margin-top: 20px;
    width: 100%;
    overflow: hidden;
    word-wrap: break-word;
    white-space: break-spaces;
    height: fit-content;
    font-size: 16px;
    background: #e1e8ed;
    line-height: 1.5;
    padding: 10px;
  }

  .upload {
    .el-upload {
      display: block !important;
    }
  }

  .lineHeight-40 {
    line-height: 40px;
  }

  .addIcon {
    color: black !important;
    font-size: 18px;
  }

  .upload-input.el-input .el-input__inner {
    cursor: pointer;
    background-color: #f5f7fa;
    border-color: #e4e7ed;
  }

  .codeRow {
    &:not(:first-child) {
      margin-top: 10px;
    }
  }

  .fileTip {
    display: flex;
    justify-content: center;
  }

  .fileName {
    margin: 0 8px;
    display: inline-block;
    max-width: 300px;
    font-weight: bold;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .errorMessage {
    color: #f56c6c;
  }
}

.optionalCode-popper.el-tooltip__popper {
  width: 400px !important;
  line-height: 1.5;
}
</style>